import React, { useReducer } from 'react';
import GrupoContext from './grupoContext';
import GrupoReducer from './grupoReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_GRUPOS,
    AGREGAR_GRUPO,
    ELIMINAR_GRUPO,
    ACTUALIZAR_GRUPO,
    GRUPO_ERROR,
    GRUPO_OK,
    GRUPO_ACTUAL,
    OBTENER_GRUPO,
    MI_ORGANIZACION
} from 'types/context';

const GrupoState = props => {
    const initialState = {
        grupos : [], // grupos del cliente
        grupo: null,
        nuevoGrupo:null,
        cliente: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null,
        miOrganizacion: [],
    }

    const [ state, dispatch ] = useReducer(GrupoReducer, initialState);

    // Obtener datos para pantalla mi Organizacion
    const miOrganizacion = async (clienteId) => {
        try {
            let resultado;
            if(clienteId){
                resultado = await clienteAxios.get(`/grupos?clienteId=${clienteId}`);
            } 
            dispatch({
                type: MI_ORGANIZACION,
                payload: resultado.data
            });        
            return resultado.data
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
        }
    }
    // Obtener los Grupos
    const obtenerGrupos = async (clienteId) => {
        try {
            // siempre deberia venir un cliente
            let resultado;
            if(clienteId){
                resultado = await clienteAxios.get(`/grupos?clienteId=${clienteId}`);
            }
            //console.log("context =>",resultado);
            dispatch({
                type: OBTENER_GRUPOS,
                payload: resultado.data.grupos
            });
            return resultado.data;            
        } catch (error) {
            const alerta = {
                msg: error?.response?.data?.message || 'Hubo un error',
                categoria: 'error'
            }            
            dispatch({
                type: GRUPO_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo grupo
    const agregarGrupo = async grupo => {
        try {
            const resultado = await clienteAxios.post('/grupos', grupo);
            // Insertar el grupo en el estado
            dispatch({
                type: AGREGAR_GRUPO,
                payload: resultado.data.grupo
            })
            const alerta = {
                msg: "Grupo creado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: GRUPO_OK,
                payload: alerta
            })
            return resultado.data.grupo
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: GRUPO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Selecciona el grupo que el usuario dio click
    const grupoActual = grupoId => {
        dispatch({
            type: GRUPO_ACTUAL,
            payload: grupoId
        })
    }

    // Elimina un grupo
    const eliminarGrupo = async grupoId => {
        try {
            await clienteAxios.delete(`/grupos/${grupoId}`);
            dispatch({
                type: ELIMINAR_GRUPO,
                payload: grupoId
            })
            const alerta = {
                msg: "Grupo eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: GRUPO_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: GRUPO_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar grupo
    const actualizarGrupo = async grupo => {

        try {
            const resultado = await  clienteAxios.put(`/grupos/${grupo.id}`, grupo);
            //console.log(resultado);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_GRUPO,
                payload: resultado.data.grupo
            }) 
            const alerta = {
                msg: "Grupo editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: GRUPO_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: GRUPO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorGrupo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: GRUPO_ERROR,
            payload: alerta
        })
    }
    const OkGrupo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: GRUPO_OK,
            payload: alerta
        })
    }
    const clearErrorGrupo = () => {
        dispatch({
            type: GRUPO_ERROR,
            payload: null,
        });
        };

    const clearOkGrupo = () => {
        dispatch({
            type: GRUPO_OK,
            payload: null,
        });
    };

    // Obtengo un grupo por id
    const obtenerGrupo = async (grupoId) => {
        try {
            
            const resultado = await clienteAxios.get(`/grupos?id=${grupoId}`);
            dispatch({
                type: OBTENER_GRUPO,
                payload: resultado.data.grupo
            })
            return resultado.data.grupo;            
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: GRUPO_ERROR,
                payload: alerta
            })
        }
    }

    return(
        <GrupoContext.Provider
            value={{
                miOrganizacion: state.miOrganizacion,
                grupos: state.grupos,
                grupo: state.grupo,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                miOrganizacion,
                obtenerGrupos,
                agregarGrupo,
                grupoActual,
                clearErrorGrupo,
                clearOkGrupo,
                eliminarGrupo,
                actualizarGrupo,
                errorGrupo,
                OkGrupo,
                obtenerGrupo,
            }}
        >{props.children}

        </GrupoContext.Provider>
    )
}
export default GrupoState;
